import {connect} from 'react-redux'
import {getQueryAirlineActionCreator} from 'data/redux/actions/guiActions';
import AirlineSelector
  from 'gui/components/editors/flightEditor/components/ticketDetailsForm/components/ticketDetails/components/airlineSelector';
import {IAirline} from 'data/interfaces/products';

const mapStateToProps = (state, {label, field}) => {
  return {label, field};
};

const mapDispatchToProps = (dispatch) => {
  return {
    queryAirline: (query) => dispatch(getQueryAirlineActionCreator(query))
      .then((airlines: IAirline[]) => airlines.map(airline => ({
        label: airline.name,
        value: airline as IAirline,
      })))
  };
};

const AirlineSelectorContainer = connect(mapStateToProps, mapDispatchToProps)(AirlineSelector as any);

export default AirlineSelectorContainer;
